import { motion } from "framer-motion";
import { scrollToSection } from "../../lib/scroll";

const fadeUp = {
  initial: { opacity: 0, y: 24 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-60px" },
  transition: { duration: 0.7 },
};

export default function RigourSection() {
  return (
    <section id="rigour" data-testid="rigour-section" className="py-24 md:py-32 border-b border-line">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <motion.p {...fadeUp} className="font-mono text-xs uppercase tracking-[0.3em] text-ochre mb-6">Research rigour</motion.p>
        <motion.h2 {...fadeUp} data-testid="rigour-heading" className="font-serif text-3xl md:text-5xl tracking-tight leading-tight max-w-4xl mb-8">
          Rigorous, First Nations-led <em className="text-ember">and protected.</em>
        </motion.h2>
        <motion.div {...fadeUp} className="space-y-6 text-stone2 leading-relaxed max-w-3xl text-lg mb-12">
          <p data-testid="rigour-body-1">
            Bigibila Governance Archaeology is a sovereign Yuwaalaraay–Gamilaraay intellectual asset developed by Liana Pitt and held within the Bigibila enterprise.
          </p>
          <p data-testid="rigour-body-2">
            The methodology supports analysis of authority, institutional responsibility, evidence, accountability and cultural risk across complex systems.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-px bg-line/40 border border-line/40">
          <motion.div {...fadeUp} className="bg-ink p-8 md:p-12">
            <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-ochre mb-6">Reliability</p>
            <p data-testid="rigour-reliability" className="font-serif text-2xl md:text-3xl leading-snug text-bone">
              Prospective independent reliability testing produced a Cohen's kappa result of <em className="text-ember">0.952</em>, indicating very strong agreement.
            </p>
          </motion.div>
          <motion.div {...fadeUp} transition={{ duration: 0.7, delay: 0.1 }} className="bg-surface1 p-8 md:p-12">
            <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-ember mb-6">Protection</p>
            <p data-testid="rigour-protection" className="text-stone2 leading-relaxed">
              The codebook, testing instruments, coding records, decision rules, scoring architecture and methodological implementation materials remain confidential and are not available for external access.
            </p>
          </motion.div>
        </div>

        <motion.div {...fadeUp} className="text-center mt-16">
          <button type="button" onClick={() => scrollToSection("briefing")} data-testid="rigour-cta" className="font-mono text-sm uppercase tracking-[0.2em] px-10 py-4 bg-ember text-ink hover:bg-emberDeep transition-colors duration-300">
            Request a Confidential Briefing
          </button>
        </motion.div>
      </div>
    </section>
  );
}
